const DASHBOARD_INITIAL_LOAD_DELAY_KEY = 'dashboardInitialLoadDelayAfterLogin';

export const authenticateUser = (token) => {
  localStorage.setItem('token', token);
  localStorage.setItem('patch', 'v2.2');
};

export const markDashboardInitialLoadForDelay = () => {
  sessionStorage.setItem(DASHBOARD_INITIAL_LOAD_DELAY_KEY, 'true');
};

export const consumeDashboardInitialLoadDelay = () => {
  const shouldDelay =
    sessionStorage.getItem(DASHBOARD_INITIAL_LOAD_DELAY_KEY) === 'true';

  sessionStorage.removeItem(DASHBOARD_INITIAL_LOAD_DELAY_KEY);
  return shouldDelay;
};

export const deauthenticateUser = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('patch');
  sessionStorage.removeItem(DASHBOARD_INITIAL_LOAD_DELAY_KEY);
  window.dispatchEvent(new Event('deauthenticateUser'));
};

export const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const clearAll = () => {
  localStorage.clear();
};
